// Identity essentials only: user_id + email. The v4 user `id` is `Profile.hash`
// (the backend Intercom sync keys contacts on that hash), so booting with it
// attaches the messenger to the same contact and avoids the integer-PK overlap
// that previously linked contacts to the wrong company (FE-1106 / FE-923).
// Company/name enrichment is intentionally not sent from the frontend — it is
// backend-owned (the account sync), per the Intercom workshop summary.
export const update = (user) => {
  if (window.Intercom && window.INTERCOME_APP_ID && user) {
    window.intercomSettings = {
      app_id: window.INTERCOME_APP_ID,
      vertical_padding: 80,
      email: user.email,
      user_id: user.id,
    }
    window.Intercom('update', window.intercomSettings)
  }
}
